import React from 'react'

import * as S from './AnalyticsChangeIndicator.styled'

type AnalyticsChangeIndicatorProps = {
  value: number
  unit?: string
  showZero?: boolean
  showValue?: boolean
  size?: 'small' | 'large'
}

const getType = (value: number): 'positive' | 'negative' | 'neutral' => {
  if (value > 0) return 'positive'
  if (value < 0) return 'negative'

  return 'neutral'
}

export const AnalyticsChangeIndicator = ({
  value,
  unit = '%',
  showZero = true,
  showValue = true,
  size = 'large',
}: AnalyticsChangeIndicatorProps) => {
  if (value === 0 && !showZero) return null

  const type = getType(value)

  return (
    <S.Container $type={type} size={size}>
      <S.Icon viewBox="0 0 14 10">
        {type === 'neutral' ? (
          <rect width="14" height="2" rx="1" y="4" />
        ) : (
          <path d="M6.21913 9.02391C6.61946 9.52432 7.38054 9.52432 7.78087 9.02391L13.7002 1.6247C14.2241 0.969934 13.7579 0 12.9194 0H1.08062C0.242118 0 -0.224055 0.969932 0.299756 1.62469L6.21913 9.02391Z" />
        )}
      </S.Icon>
      {showValue && (
        <S.Value>
          {Math.abs(value)}
          {unit}
        </S.Value>
      )}
    </S.Container>
  )
}
